import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { StatusColor } from 'src/app/shared/status-indicator/status-indicator.component';

@Component({
  selector: 'release-status',
  template: `<dcc-status-indicator
    [color]="getStatusColor(status)"
    [value]="status"
  ></dcc-status-indicator>`,
})
export class ReleaseStatusComponent implements ICellRendererAngularComp {
  status: string;
  statusCss: string;
  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.status = this.getStatusName(
      params.data.status,
      params.data.hasPendingApproval,
    );
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.status = params.data.status;
    return true;
  }

  getStatusColor(status: string): StatusColor {
    switch (status) {
      case 'Pending':
        return StatusColor.yellow;
      case 'In Progress':
        return StatusColor.blue;
      case 'Deployed':
        return StatusColor.green;
      case 'Rejected':
        return StatusColor.red;
      case 'Disabled':
        return StatusColor.red;
      case 'Scheduled':
        return StatusColor.yellow;
      default:
        return undefined;
    }
  }

  getStatusName(status: string, hasPendingApproval: boolean): string {
    let baseStatus = status;
    switch (status) {
      case 'PendingReview':
        return 'Pending Review';
      case 'InProgress':
        baseStatus = 'In Progress';
        break;
      default:
        break;
    }

    if (hasPendingApproval) {
      return `${baseStatus} (Awaiting Approval)`;
    }

    return baseStatus;
  }
}
